<template>
     <div class="container" v-title="'中企体协'">
        <div class="container_content">
            <div id="Association">
                <div class="header">
                    <div class="logo">
                        <YD-image src="中企体协logo"></YD-image>
                    </div>
                    <div class="tab">
                        <ul>
                            <li @click="open()">发展历程</li>
                            <li @click="go('/Association/Constitution')">协会章程</li>
                            <li @click="go('/Association/OrganizationalStructure')">组织架构</li>
                            <li @click="go('/Association/CoreTeam')">核心团队</li>
                            <li @click="go('/Association/MemberList')">会员家庭</li>
                            <li @click="go('/Association/Business')">业务领域</li>
                            <li @click="go('/Association/CooperativeResources')">合作资源</li>
                            <li @click="go('/Association/OfficialMedia')">官方媒体</li>
                        </ul>
                    </div>
                </div>
                <div class="Association_scroll" v-scroll="roll">
                    <div class="Association_content">
                        <div class="video_info">
                            <div class="video">
                                <video ref="video" width="100%" :poster="poster" :src="src" controls controlsList="nodownload" x5-video-player-type='h5' x5-video-player-fullscreen='true' playsinline webkit-playsinline></video>
                            </div>
                            <div class="video_text">
                                <div>
                                    <YD-image src="icon/icon_三角"></YD-image>
                                    <span>视频介绍</span>
                                </div>
                                <div>总时长 6:17</div>
                            </div>
                        </div>
                        <div class="info">
                            <p>中国企业体育协会于1988年由原国家体委群体司牵头成立，前身是全国大企业办运动队联合会，2008年更名为中国企业体育协会，是在民政部注册、接受国家体育总局业务指导的跨行业、全国性体育社团组织，是中华全国体育总会的团体会员，是引领中国职工体育运动发展的权威管理机构。</p>
                            <p>2016年底，协会完成与国家体育总局行政脱钩，在中央国家机关工委、国家体育总局、民政部等单位的共同指导下进入全新运营阶段。2018年，协会加入世界企业体育联合会，成为联合会负责亚洲事务副主席单位。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </div>
</template>
<script>
import {
    convertSize
} from '@js';
import { 
    webviewOpenUrl
} from "@js/appInteraction"
export default {
    name:"AssociationHome",
    data(){
        return {
            roll:0,
            poster: "https://video.dazhongyundong.com/image/cover/CA3C3AA63D5D4929B487183143AE8A3A-6-2.png",
            src: "https://video.dazhongyundong.com/a26f4532f56f48829a5eb454dff2f9e0/eb5d1b59b811404cae0d596109eb729a-52fee972954558bfa3c503eab2864c0f-ld.mp4"
        }
    },
    mounted(){
        var _this = this;
        window.onblur = ()=>{
            _this.$refs['video'].pause();
        }
    },
    destroyed(){
        window.onblur = null;
    },
    methods:{
        open(){
            var h = this.$refs['video_info'].offsetHeight;
            this.roll = h + convertSize(0.34);
        },
        go(url){
            if(process.env.NODE_ENV == "production"){
                webviewOpenUrl(process.env.VUE_APP_PUBLIC_URL+ '/#' + url);
            }else{
                this.$navigation.go(url);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#Association{
    overflow: hidden;
}
.header{
    height: 264px;
    width: 100%;
    background: #FFFFFF;
    .logo{
        height:104px;
        width: 100%;
        padding-top: 16px;
        box-sizing: border-box;
        img{
            width: 72px;
            height: 72px;
            display: block;
            margin: 0 auto;
        }
    }
    .tab{
        height: auto;
        width: 100%;
        padding: 0 40px;
        box-sizing: border-box;
        ul{
            height: auto;
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            li{
                width: 160px;
                @include line-height(64px);
                font-size: 28px;
                color: #EC1B24;
                text-align: center;
                font-weight: 500;
                border-radius: 40px;
                box-shadow: 0 8px 10px rgba(245,211,211,0.64);
                margin-bottom: 16px;
            }
        }
    }
}
.Association_scroll{
    width: 100%;
    height: calc(100% - 264px);
    overflow-y: auto;
    .Association_content{
        width: 100%;
        padding: 24px 40px 40px;
        box-sizing: border-box;
        .video_info{
            width: 100%;
            background: #FFFFFF;
            border: 1px solid rgba(236,27,36,1);
            border-bottom: none;
            border-radius: 20px;
            box-sizing: border-box;
            position: relative;
            z-index: 1;
            .video{
                width: 100%;
                min-height: 375px;
                border-radius: 20px;
                overflow: hidden;
                video{
                    width: 100%;
                    vertical-align: top;
                }
            }
            .video_text{
                height: 104px;
                width: 100%;
                padding: 0 32px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                >div:nth-of-type(1){
                    display: flex;
                    align-items: center;
                    opacity: 0.9;
                    font-size: 32px;
                    color: #1B1C1E;
                    line-height: 40px;
                    font-weight: 500;
                    img{
                        width: 36px;
                        height: 36px;
                        margin-left: -8px;
                        margin-right: 14px;
                    }
                }
                >div:nth-of-type(2){
                    font-size: 28px;
                    color: #575757;
                    line-height: 38px;
                    font-weight: 400;
                }
            }
        }
        .info{
            width: 100%;
            min-height: 694px;
            background-image:url('~@images/Association/bg@2x.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            padding: 0 24px;
            padding-top: 148px;
            margin-top: -116px;
            padding-bottom: 32px;
            box-sizing: border-box;
            .name{
                margin-bottom: 32px;
                h2{
                    font-size: 44px;
                    color: #FFFFFF;
                    letter-spacing: 1.3px;
                    font-weight: 500;
                    margin-bottom: 4px;
                }
                p{
                    font-size: 28px;
                    color: #FFFFFF;
                    letter-spacing: 0.5px;
                    font-weight: 400;
                }
            }
            .subtitle{
                font-size: 32px;
                color: #FFFFFF;
                line-height: 40px;
                font-weight: 500;
                margin-left: -20px;
                margin-bottom: 24px;
            }
            >p{
                font-size: 28px;
                color: #FFFFFF;
                line-height: 44px;
                font-weight: 400;
                margin-bottom: 16px;
                text-indent: 2em;
            }
        }
    }
}
</style>